import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import Truncate from "react-truncate";

import cx from 'classnames';
import _ from 'lodash';
import dateformat from "dateformat";

import { TrendsLineChart } from './charts'

import { fetchPageMetricsForType, fetchStoryboardLeadsTimeSeries } from 'actions/storyboardReports';
import { convertDatesToTimezone } from 'services/report.service';
import { padNumber } from 'services/util';

import { VisitorProfileView, LeadAnalyticsHeader, TableInfo, EmptyMessage, LoadingMessage } from '.';
import { TableFooter } from './tableFooter';

import styles from '../report.module.scss';

export function LeadAnalytics(props) {
  const dispatch = useDispatch();

  let { storyboardId } = useParams();
  const leads = useSelector(state => _.get(state, `storyboards.storyboard.reports.metrics.leads.items`));
  const views = useSelector(state => _.get(state, 'storyboards.storyboard.reports.leadTimeSeries.items'));
  const pagination = useSelector(state => _.get(state, `storyboards.storyboard.reports.metrics.leads.pagination`));
  const loading = useSelector(state => _.get(state, `storyboards.storyboard.reports.metrics.leads.loading`));
  const [currentChart, setCurrentChart] = useState("table_view");

  useEffect(() => {
    if (props.date) {
      handlePageChange(0);

      var request = {
        storyboard: storyboardId,
        ...convertDatesToTimezone(props.date),
      }

      dispatch(fetchStoryboardLeadsTimeSeries(request));
    }
  }, [props.date]);

  const handlePageChange = (page) => {
    handleFetchPageViewsReport(page);
  }

  const handleFetchPageViewsReport = (page) => {
    var request = {
      storyboard: storyboardId,
      metricType: "leads",
      ...convertDatesToTimezone(props.date),
    }

    dispatch(fetchPageMetricsForType(request, page, 5));
  }

  const handleChartChange = (value) => {
    setCurrentChart(value)
  }

  return (
    <div className={styles.leadsAnalyticsWrapper}>
      <div className={styles.leadsAnalyticsContainer}>
        <TableInfo
          name="Lead Analytics"
          pagination={pagination} />

        {currentChart == "table_view" && <LeadAnalyticsHeader />}

        {currentChart == "table_view" &&
          !loading && leads && leads.map((data, index) => {
            return <LeadReportView loading={loading} reportDate={props.date} showProfile={props.showProfile} data={data} index={index} />
          })
        }

        {currentChart == "graph_view" &&
          <div className={cx(styles.graphFullView, { [styles.emptyGraph]: (views && views.length == 0) })}>
            <TrendsLineChart data={views} height={400} />
          </div>
        }

        {loading && (leads && leads.length > 0) &&
          <LoadingMessage />
        }

        {(leads && leads.length == 0) && !loading &&
          <EmptyMessage />
        }
      </div>

      <TableFooter
        currentChart={currentChart}
        disableView={['pie_chart_view']}
        handleChartChange={handleChartChange}
        handlePageChange={handlePageChange}
        pagination={pagination}
        paginationName={"Leads"}
      />
    </div>
  )
}

function LeadReportView({ loading, data, reportDate, showProfile, index }) {
  if (!data || data.length <= 1) {
    return false;
  }

  const _renderTimeSpent = (seconds) => {
    let minutes = padNumber(Math.floor(seconds / 60), 2);
    seconds = padNumber(Math.floor(seconds % 60), 2);
    var hours = padNumber(Math.floor(minutes / 60), 2);
    minutes = padNumber(minutes % 60, 2);

    hours = hours > 0 ? `${hours}:` : '00'
    return `${hours}:${minutes}:${seconds}`;
  }

  return (
    <div key={index} className={styles.leadsAnalyticsRow}>
      <VisitorProfileView
        data={data}
        reportDate={reportDate}
        showProfile={showProfile}
        type="leads"
      />

      <div className={cx(styles.wrapper, styles.sourceColumn)}>
        <div className={styles.headline}>
          <Truncate width={180} lines={1}>
            {data.campaignSource ? `${data.campaignSource},${data.campaignMedium}` : "-"}
          </Truncate>
        </div>
        <div className={styles.description}>
          <Truncate width={180} lines={1}>
            {data.landingPageUrl}
          </Truncate>
        </div>
      </div>

      <div className={cx(styles.wrapper, styles.campaignColumn)}>
        <div className={styles.headline}>
          <Truncate width={100} lines={1}>
            {data.campaignName ? data.campaignName : "-"}
          </Truncate>
        </div>
      </div>

      <div className={cx(styles.wrapper, styles.createdDateColumn)}>
        <div className={styles.headline}>{dateformat(data.contact.createdDate, 'dd mmm yyyy')}</div>
      </div>

      <div className={cx(styles.wrapper, styles.lastVisitedColumn)}>
        <div className={styles.headline}>{dateformat(data.lastVisitedDate, 'dd mmm yyyy')}</div>
      </div>

      <div className={cx(styles.wrapper, styles.viewsColumn)}>
        <div className={styles.headline}>{data.views}</div>
      </div>

      <div className={cx(styles.wrapper, styles.timeSpentColumn)}>
        <div className={styles.headline}>{_renderTimeSpent(data.timeSpent)}</div>
      </div>

      <div className={cx(styles.wrapper, styles.completionColumn)}>
        <div className={styles.headline}>{`${data.completion} %`}</div>
      </div>
    </div>
  )
}